import React, { useRef } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Player } from '@lottiefiles/react-lottie-player'
import data from 'data/MenuBird.json'

//import { ThemeContext } from 'helpers/ThemeProvider'

import {
  Wrapper,
  Overflow,
  Logo,
  MenuWrap,
  Item,
  Li,
  Primary,
  CloseButton,
  Apply,
  Insta,
} from './index.styled'

const Menu = () => {
  const {
    menuContent: { content: links },
  } = useStaticQuery(graphql`
    query MenuQuery {
      menuContent {
        content {
          title
          url
        }
      }
    }
  `)

  const menuRef = useRef(null)
  //const { scrollerSmoother } = React.useContext(ThemeContext)

  const onClose = () => {
    const btn = document.querySelector('.home-wrapper')
    btn.classList.toggle('open-menu')
    /*  

    scrollerSmoother.current.paused(false) */
  }

  return (
    <>
      <Wrapper id={'menu'} ref={menuRef}>
        <MenuWrap>
          <Logo to={'/'} onClick={onClose} />

          <CloseButton onClick={onClose} />
          <Primary>
            {links.map((item, index) => (
              <Li key={`primary-item-${index}`} onClick={onClose}>
                <Player autoplay src={data} className={'bird'} loop></Player>
                <Item to={item.url}>{item.title}</Item>
              </Li>
            ))}
          </Primary>
          <Apply
            href={'https://www.on-site.com/apply/property/676929'}
            onClick={onClose}
            target={'_blank'}
            rel="noreferrer"
          >
            apply now
          </Apply>
          <Insta
            href={'https://www.instagram.com/mabelchelseanyc/'}
            target={'_blank'}
            rel="noreferrer"
          />
        </MenuWrap>
      </Wrapper>
      <Overflow />
    </>
  )
}

export default Menu
